"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Image = _interopRequireDefault(require("../Image"));
var _Text = _interopRequireDefault(require("../Text"));
var _Title = _interopRequireDefault(require("../Title"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _SsrModalHeader = _interopRequireDefault(require("./SsrModalHeader.proptypes"));
var _constant = require("./constant");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var MainWrapper = _styledComponents.default.div.withConfig({
  displayName: "SsrModalHeader__MainWrapper",
  componentId: "sc-1idbncx-0"
})(["background-color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.default;
});
var TileWrapper = _styledComponents.default.div.withConfig({
  displayName: "SsrModalHeader__TileWrapper",
  componentId: "sc-1idbncx-1"
})([""]);
var Tile = _styledComponents.default.div.withConfig({
  displayName: "SsrModalHeader__Tile",
  componentId: "sc-1idbncx-2"
})(["display:flex;flex-direction:row;margin:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.space.none, " ").concat(theme.space.small);
});
var ImageContainer = _styledComponents.default.div.withConfig({
  displayName: "SsrModalHeader__ImageContainer",
  componentId: "sc-1idbncx-3"
})([""]);
var TileDescription = _styledComponents.default.div.withConfig({
  displayName: "SsrModalHeader__TileDescription",
  componentId: "sc-1idbncx-4"
})(["display:flex;flex-direction:column;justify-content:center;"]);
var CustomHeading = (0, _styledComponents.default)(_Title.default).withConfig({
  displayName: "SsrModalHeader__CustomHeading",
  componentId: "sc-1idbncx-5"
})(["line-height:", ";margin-bottom:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.lineHeight.XXLarge;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.micro;
});
var TabListWrapper = _styledComponents.default.div.withConfig({
  displayName: "SsrModalHeader__TabListWrapper",
  componentId: "sc-1idbncx-6"
})(["cursor:pointer;overflow:auto;text-align:center;white-space:nowrap;-ms-overflow-style:auto;scrollbar-width:auto;&::-webkit-scrollbar{display:block;height:8px;}&::-webkit-scrollbar-thumb{background:", ";border-radius:4px;}&::-webkit-scrollbar-track{background:", ";}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.greyLight;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.greyLighter;
});
var TabItem = _styledComponents.default.div.withConfig({
  displayName: "SsrModalHeader__TabItem",
  componentId: "sc-1idbncx-7"
})(["display:inline-block;position:relative;width:", ";&::after{border-radius:", ";content:'';position:absolute;bottom:0;left:0;right:0;background:", ";height:", ";border-radius:", ";}"], function (_ref7) {
  var tabWidth = _ref7.tabWidth;
  return tabWidth;
}, function (_ref8) {
  var theme = _ref8.theme;
  return "".concat(theme.space.micro, " ").concat(theme.space.micro, " 0 0");
}, function (_ref9) {
  var isSelected = _ref9.isSelected,
    theme = _ref9.theme;
  return isSelected ? "".concat(theme.colors.secondary) : "none";
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.space.mini;
}, function (_ref11) {
  var theme = _ref11.theme;
  return "".concat(theme.space.mini, " ").concat(theme.space.mini, " 0 0");
});
var TabInfo = _styledComponents.default.div.withConfig({
  displayName: "SsrModalHeader__TabInfo",
  componentId: "sc-1idbncx-8"
})(["display:flex;justify-content:center;padding:", ";svg{margin-right:", ";}"], function (_ref12) {
  var theme = _ref12.theme;
  return "".concat(theme.space.small);
}, function (_ref13) {
  var theme = _ref13.theme;
  return "".concat(theme.space.medium);
});
var SsrModalHeader = function SsrModalHeader(_ref14) {
  var accessible = _ref14.accessible,
    theme = _ref14.theme,
    customProperties = _ref14.customProperties,
    translation = _ref14.translation,
    isMobile = _ref14.isMobile,
    ssrType = _ref14.ssrType,
    handleTabSelection = _ref14.handleTabSelection,
    selectedTab = _ref14.selectedTab,
    tabList = _ref14.tabList,
    hideTileHeader = _ref14.hideTileHeader;
  var language = _objectSpread(_objectSpread({}, _constant.TRANSLATION), translation);
  var getTile = function getTile() {
    return /*#__PURE__*/_react.default.createElement(Tile, null, /*#__PURE__*/_react.default.createElement(ImageContainer, null, /*#__PURE__*/_react.default.createElement(_Image.default, {
      theme: theme,
      accessible: accessible,
      alt: "".concat(ssrType, "-icon"),
      borderColor: "default",
      placeHolderBackground: "greyLighter",
      src: _constant.IMAGE_TYPE[ssrType].tileLogo.src,
      height: _constant.IMAGE_TYPE[ssrType].tileLogo.height,
      width: _constant.IMAGE_TYPE[ssrType].tileLogo.width
    })), /*#__PURE__*/_react.default.createElement(TileDescription, null, /*#__PURE__*/_react.default.createElement(CustomHeading, {
      accessible: accessible,
      inverted: false,
      textAlign: "left",
      type: "h3"
    }, language["".concat(ssrType, "Title")]), /*#__PURE__*/_react.default.createElement(_Text.default, {
      theme: theme,
      accessible: accessible,
      type: _constant.TEXT_TYPE.small.type,
      color: _constant.TEXT_TYPE.small.color
    }, language["".concat(ssrType, "TileDescription")])));
  };
  var getTabItem = function getTabItem(tabItem) {
    var fontColor = selectedTab === tabItem.id ? 'neutral' : 'greyLight';
    return /*#__PURE__*/_react.default.createElement(TabInfo, null, tabItem.icon && /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: accessible,
      color: selectedTab === tabItem.id && 'greyDark' || fontColor,
      fontsize: "XLarge",
      icon: tabItem.icon,
      theme: theme
    }), /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      color: fontColor,
      display: "inlineFlex",
      hasToggle: false,
      opacity: 1,
      tag: "p",
      theme: theme,
      translation: {},
      type: "default",
      verticalAlign: "center"
    }, tabItem.label));
  };
  var getTabWidth = function getTabWidth(tabCount) {
    var customWidth = 100 / tabCount;
    var defaultMultiTabWidth = isMobile ? 50 : 25;
    switch (tabCount) {
      case 1:
        return '100%';
      case 2:
        return '50%';
      default:
        return "".concat(customWidth < defaultMultiTabWidth ? defaultMultiTabWidth : customWidth, "%");
    }
  };
  var getTabList = function getTabList() {
    var tabWidth = getTabWidth(tabList && tabList.length > 0 ? tabList.length : 1);
    return tabList.map(function (tab) {
      return /*#__PURE__*/_react.default.createElement(TabItem, {
        tabWidth: tabWidth,
        onClick: function onClick() {
          return handleTabSelection(tab.id);
        },
        isSelected: selectedTab === tab.id,
        key: "tab-item-".concat(tab.id)
      }, getTabItem(tab));
    });
  };
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(MainWrapper, (0, _extends2.default)({}, customProperties, {
    isMobile: isMobile
  }), !hideTileHeader && /*#__PURE__*/_react.default.createElement(TileWrapper, null, getTile()), /*#__PURE__*/_react.default.createElement(TabListWrapper, null, getTabList())));
};
SsrModalHeader.propTypes = _SsrModalHeader.default.PropTypes;
SsrModalHeader.defaultProps = _SsrModalHeader.default.DefaultProps;
var _default = SsrModalHeader;
exports.default = _default;